import { p as proxyCustomElement, H, h, c as Host } from './p-0498a6af.js';
import { i as inheritAriaAttributes, n as nanoid, c as clsx } from './p-70e482d1.js';

const stylesCss = ":host{display:inline-block}:host svg{display:block;width:1em;height:1em;fill:currentColor}:host(.size-2xl){font-size:var(--bi-icon-2xl) !important}:host(.size-xl){font-size:var(--bi-icon-xl) !important}:host(.size-large){font-size:var(--bi-icon-large) !important}:host(.size-medium){font-size:var(--bi-icon-medium) !important}:host(.size-small){font-size:var(--bi-icon-small) !important}:host(.color-inherit){color:inherit}:host(.color-primary){color:#01417b}:host(.color-gray){color:#1c1b1b}:host(.color-black){color:var(--bi-basic-key)}:host(.color-white){color:var(--bi-basic-white)}";
const BiIconSchoolStyle0 = stylesCss;

const BiIconSchool$1 = /*@__PURE__*/ proxyCustomElement(class BiIconSchool extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.inheritedAttributes = {};
        this.titleText = null;
        /**
         * The color of the icon.
         * @default 'inherit'
         */
        this.color = 'inherit';
    }
    componentWillLoad() {
        this.inheritedAttributes = inheritAriaAttributes(this.el);
        this.titleText = this.el.getAttribute('title');
        if (this.titleText) {
            this.titleId = `title-${nanoid()}`;
        }
    }
    render() {
        return (h(Host, { key: '7a7ba66f24814180fb9f4de52656b8ceee9541e3', class: clsx(`color-${this.color}`, this.size && `size-${this.size}`) }, h("svg", { key: '2d64d4399789ac3b223f212012685caad408ebbd', xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 25 25', focusable: 'false', role: 'img', width: '1em', height: '1em', fill: 'currentColor', "aria-labelledby": this.titleId, ...this.inheritedAttributes }, this.titleText ? h("title", { id: this.titleId }, this.titleText) : null, h("path", { key: 'adc5cc7d49d7fe9bd0b919a5a149b0f2156febf4', "fill-rule": 'evenodd', d: 'm12.863 3.626 8.964 6.94-2.867 2.22a7.208 7.208 0 0 1 1.393 4.27v2.996h-1.5v-2.995c0-.071 0-.141-.003-.211L12.866 21.5l-7.243-5.572v-.37c0-.846.152-1.497.428-2.065.153-.315.34-.593.534-.848l-2.686-2.079zm-5.092 9.937a3.44 3.44 0 0 0-.37.585c-.132.27-.231.596-.265 1.051l5.725 4.404 5.68-4.418a5.73 5.73 0 0 0-.767-1.48l-4.91 3.8zm10.18-1.893a7.214 7.214 0 0 0-4.838-1.854v1.5c1.376 0 2.639.484 3.627 1.291l-3.877 3.002-6.513-5.043 6.513-5.043 6.514 5.043z', "clip-rule": 'evenodd' }))));
    }
    get el() { return this; }
    static get style() { return BiIconSchoolStyle0; }
}, [1, "bi-icon-school", {
        "size": [513],
        "color": [513]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["bi-icon-school"];
    components.forEach(tagName => { switch (tagName) {
        case "bi-icon-school":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, BiIconSchool$1);
            }
            break;
    } });
}

const BiIconSchool = BiIconSchool$1;
const defineCustomElement = defineCustomElement$1;

export { BiIconSchool, defineCustomElement };
